// Libs
import ApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { useMemo, useState } from "react";
// Types
import { ChartSetNine } from "../Libs/Types/ChartTypes";
// Utils
import {
  chartColors,
  CHART_AXIS_FALLBACK,
  humanize,
  chartHeight,
} from "../Libs/Utils/utils";
// UI-Components
import ChartFallBack from "../UI-Components/ChartFallback";

export default function ScatterChart({
  chartData,
  dataKey,
}: {
  chartData: ChartSetNine["ScatterChart"];
  dataKey: string;
}) {
  // Assign a unique color to this chart instance ONCE
  const [chartColor] = useState(() => chartColors);
  // If you have multi-series, you can generate a list of random colors ONCE per chart
  const colorList = useMemo(() => {
    if (!chartData || !Array.isArray(chartData["data"][0]?.data)) return [];
    return chartData["data"][0].data.map(() => chartColors);
  }, [chartData]);
  const option: ApexOptions = {
    chart: {
      fontFamily: "Poppins",
      toolbar: {
        show: true,
      },
    },
    title: {
      style: { fontSize: "14px", fontWeight: "900" },
      text:
        chartData !== undefined
          ? chartData["title"]
          : CHART_AXIS_FALLBACK["title"],
      align: "left",
    },
    dataLabels: {
      style: {
        fontSize: "8px",
      },
    },
    legend: {
      show: false,
    },
    fill: {
      colors: colorList.length > 0 ? colorList : [chartColor], // Use colorList for multi-series, or chartColor for single
      opacity: 0.9,
    },
    colors: colorList.length > 0 ? colorList : [chartColor], // Also set here for line/area color[2][3]
    xaxis: {
      tickAmount: 10,
      labels: {
        formatter: function (val) {
          return parseFloat(val).toFixed(1);
        },
        style: {
          fontSize: "8px",
        },
      },
    },
    tooltip: {
      y: {
        title: {
          formatter: function (seriesName) {
            return humanize(seriesName);
          },
        },
      },
    },
    yaxis: {
      tickAmount: 7,
      labels: {
        style: {
          fontSize: "8px",
        },
      },
    },
  };

  const series: any =
    chartData !== undefined &&
    Array.isArray(chartData["data"][0]["data"]) === true
      ? chartData["data"][0]["data"]
      : undefined;

  return (
    <div className="my-2 chartWrp border-1 rounded-lg w-full p-2">
      {series !== undefined ? (
        <ApexChart
          type="scatter"
          options={option}
          series={series}
          height={chartHeight}
          width={"100%"}
          key={dataKey}
        />
      ) : (
        <ChartFallBack />
      )}
    </div>
  );
}
